"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
// Updates the height of a <textarea> when the value changes.
var useAutosizeTextArea = function (textAreaRef, value) {
    (0, react_1.useEffect)(function () {
        if (textAreaRef) {
            // We need to reset the height momentarily to get the correct scrollHeight for the textarea
            textAreaRef.style.height = "0px";
            var scrollHeight = textAreaRef.scrollHeight;
            // We then set the height directly, outside of the render loop
            // Trying to set this with state or a ref will product an incorrect value.
            textAreaRef.style.height = scrollHeight + "px";
        }
    }, [textAreaRef, value]);
};
exports.default = useAutosizeTextArea;
